export const STANDARD_LANGUAGES = [
  { value: 'English', label: 'English (English)' },
  { value: 'Urdu', label: 'Urdu (اردو)' },
  { value: 'Arabic', label: 'Arabic (العربية)' },
  { value: 'Spanish', label: 'Spanish (Español)' },
  { value: 'French', label: 'French (Français)' },
  { value: 'German', label: 'German (Deutsch)' },
  { value: 'Hindi', label: 'Hindi (हिन्दी)' },
  { value: 'Punjabi', label: 'Punjabi (ਪੰਜਾਬੀ / پنجابی)' },
  { value: 'Bengali', label: 'Bengali (বাংলা)' },
  { value: 'Turkish', label: 'Turkish (Türkçe)' },
  { value: 'Italian', label: 'Italian (Italiano)' },
  { value: 'Portuguese', label: 'Portuguese (Português)' },
  { value: 'Russian', label: 'Russian (Русский)' },
  { value: 'Chinese', label: 'Chinese (中文)' },
  { value: 'Japanese', label: 'Japanese (日本語)' },
  { value: 'Persian', label: 'Persian (فارسی)' },
  { value: 'Pashto', label: 'Pashto (پښتو)' },
  { value: 'Dutch', label: 'Dutch (Nederlands)' },
  { value: 'Polish', label: 'Polish (Polski)' },
  { value: 'Greek', label: 'Greek (Ελληνικά)' },
  { value: 'Indonesian', label: 'Indonesian (Bahasa Indonesia)' },
  { value: 'Malay', label: 'Malay (Bahasa Melayu)' },
  { value: 'Tagalog', label: 'Tagalog (Filipino)' },
  { value: 'Swahili', label: 'Swahili (Kiswahili)' },
  { value: 'Somali', label: 'Somali (Soomaali)' },
  { value: 'Gujarati', label: 'Gujarati (ગુજરાતી)' },
  { value: 'Tamil', label: 'Tamil (தமிழ்)' },
  { value: 'Telugu', label: 'Telugu (తెలుగు)' },
  { value: 'Marathi', label: 'Marathi (मराठी)' },
  { value: 'Vietnamese', label: 'Vietnamese (Tiếng Việt)' },
  { value: 'Korean', label: 'Korean (한국어)' },
  { value: 'Thai', label: 'Thai (ไทย)' },
  { value: 'Swedish', label: 'Swedish (Svenska)' },
  { value: 'Norwegian', label: 'Norwegian (Norsk)' },
  { value: 'Danish', label: 'Danish (Dansk)' },
  { value: 'Finnish', label: 'Finnish (Suomi)' },
  { value: 'Romanian', label: 'Romanian (Română)' },
  { value: 'Czech', label: 'Czech (Čeština)' },
  { value: 'Hungarian', label: 'Hungarian (Magyar)' },
  { value: 'Ukrainian', label: 'Ukrainian (Українська)' },
  { value: 'Hebrew', label: 'Hebrew (עברית)' }
];
